export const log_in = {
  en: {
    'Sign In': 'Sign In',
    Email: 'Email',
    Password: 'Password',
    'Remember me': 'Remember me',
  },
};
